module.exports = __webpack_public_path__ + "img/logo.09de9c30.png";